import lodash from 'lodash';
import container from './basicContainer.js'
let obj2 = lodash.cloneDeep(container.children[0])
let obj3 = lodash.cloneDeep(obj2.children[0])
export const obj = obj2

export const componentObj = obj3